import React, { useState, useEffect, useRef } from 'react';
import ShopifyIcon from './ShopifyIcon';
import WooIcon from './WooIcon';
import SlackIcon from './SlackIcon';
import './IntegrationIcons.css';
import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import CallbackPage from '../Pages/CallbackPage';
import { useAuth } from '../hooks/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebaseConfig';
import useShopifyConnection from '../hooks/useShopifyConnection';
// ... (import statements)

function IntegrationIcons() {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const modalRef = useRef(null);
  const { user } = useAuth();
  const {
    isConnecting,
    isConnected,
    errorMessage,
    connect,
    setErrorMessage,
    shopifyUrlForFirebase,
    setShopifyUrlForFirebase,
  } = useShopifyConnection();

  useEffect(() => {
    if (user) {
      checkIfConnected();
    }
  }, [user]);

  useEffect(() => {
    if (shopifyUrlForFirebase) {
      setModalContent(
        <div ref={modalRef} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <Input
            value={shopifyUrlForFirebase}
            onChange={(e) => setShopifyUrlForFirebase(e.target.value)}
            placeholder='Enter your Shopify URL'
            variant='outlined'
            onClick={(e) => e.stopPropagation()}
          />

          {!isConnecting && !isConnected && (
            <Button variant='contained' color='primary' onClick={handleConnectIcon}>
              👉 Connect Now
            </Button>
          )}

          {isConnecting && <p>Connecting to Shopify...</p>}

          {isConnected && <CallbackPage />}
          {/* Afficher CallbackPage uniquement lorsque la connexion est réussie */}
        </div>
      );
    }
  }, [shopifyUrlForFirebase, isConnecting, isConnected, setShopifyUrlForFirebase]);

  const checkIfConnected = async () => {
    try {
      const userRef = doc(db, 'Shopify', user.uid);
      const docSnap = await getDoc(userRef);
      if (docSnap.exists()) {
        setShopifyUrlForFirebase(docSnap.data().shopifyUrl); // Fetch the initial URL from Firebase
      }
    } catch (error) {
      console.error('Error checking connection:', error);
    }
  };

  const handleConnectIcon = async () => {
    try {
      if (!shopifyUrlForFirebase) {
        setErrorMessage('Shopify URL is required.');
        return;
      }

      await connect(shopifyUrlForFirebase);
    } catch (error) {
      console.error('Error connecting to Shopify:', error);
    }
  };

  const handleOutsideClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setShowModal(false);
      setModalContent(null);
      setErrorMessage('');
    }
  };

  const handleIconClick = (icon) => {
    setModalContent(
      icon === 'Shopify' ? (
        <div ref={modalRef} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <Input
            value={shopifyUrlForFirebase}
            onChange={(e) => setShopifyUrlForFirebase(e.target.value)}
            placeholder='Enter your Shopify URL'
            variant='outlined'
            onClick={(e) => e.stopPropagation()}
          />

          {!isConnecting && !isConnected && (
            <Button variant='contained' color='primary' onClick={handleConnectIcon}>
              👉 Connect Now
            </Button>
          )}

          {isConnecting && <p>Connecting to Shopify...</p>}

          {isConnected && <CallbackPage />}
          {/* Afficher CallbackPage uniquement lorsque la connexion est réussie */}
        </div>
      ) : (
        <p>{`${icon} integration will be soon available!`}</p>
      )
    );

    setShowModal(true);
  };

  return (
    <div className='IntegrationIcons'>
      <ShopifyIcon onClick={() => handleIconClick('Shopify')} />
      <WooIcon onClick={() => handleIconClick('WooCommerce')} />
      <SlackIcon onClick={() => handleIconClick('Slack')} />

      {showModal && (
        <div className='modal' onClick={handleOutsideClick}>
          <div className='modal-content' onClick={(e) => e.stopPropagation()}>
            {modalContent}
            {errorMessage && <p>Error: {errorMessage}</p>}
          </div>
        </div>
      )}
    </div>
  );
}

export default IntegrationIcons;
